import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import HotelDetails from '../HotelDetails';
import Container from '../../../layout/Container';

const HotelPage: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" })
    }, [])

    const paragraphs = t("hotelPage.paragraphs", { returnObjects: true }) as string[];

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("specificOffer.hotel.title")}</title>
                <meta name="description" content={t("specificOffer.hotel.title")} />
            </Helmet>
            <Box mt={{ xs: 6, sm: 8 }}>
                <HotelDetails />
            </Box>
            <Container>
                <Box mt={{ xs: 1, md: 0 }} pb={{ xs: 4, md: 6 }}>
                    {paragraphs.map((paragraph, index) => (
                        <Typography key={`hotel-paragraph-${index}`} color="text2.primary" mb={2}>
                            {paragraph}
                        </Typography>
                    ))}
                </Box>
            </Container>
        </>
    );
};

export default HotelPage;
